export const LOCAL_STORAGE_KEY = "recently_viewed";
